import AddIcon from "@mui/icons-material/Add";

import { Button } from "@covertree/ui";
import { DISABLED_TOOLTIP_TEXT } from "@consts/index";

interface Props {
  canManageEndorsements: boolean;
  isEligibilityLoading: boolean;
  handleCreateNewEndorsement: () => void;
}

export const AddEndorsementButton = ({
  canManageEndorsements,
  handleCreateNewEndorsement,
  isEligibilityLoading,
}: Props) => {
  return (
    <Button
      tooltipPlacement="top"
      tooltip={canManageEndorsements ? "" : DISABLED_TOOLTIP_TEXT}
      disabled={!canManageEndorsements || isEligibilityLoading}
      loading={isEligibilityLoading}
      variant="outlined"
      size="small"
      startIcon={<AddIcon />}
      onClick={handleCreateNewEndorsement}
      sx={{ "& .MuiButton-startIcon": { mt: "-2px" } }}>
      New Endorsement
    </Button>
  );
};
